module.exports = __webpack_public_path__ + "img/StonemartLogo.95d623fb.png";